import { getOrganisation } from '@/domain/organisation/actions/get-organisation.action';
import { Organisation } from '@/domain/organisation/entities/organisation.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  organisation: Organisation;
};

export const createOrganisation = createAppAsyncThunk(
  'organisation/createOrganisation',
  async (
    params: Params,
    { extra: { organisationGateway, snackbarGateway }, dispatch },
  ): Promise<void> => {
    try {
      await organisationGateway.createOrganisation(params.organisation);
      showSnackbarSuccess(snackbarGateway);
      dispatch(getOrganisation());
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('CreateOrganisation.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('CreateOrganisation.Message.error'));
}
